export default __webpack_public_path__ + "static/media/photo.b91303bd.png";